import React__default from 'react';
import { Tooltip } from 'antd';
import Flag from './../../../../external/react-world-flags/dist/react-world-flags.js';
import DmCountry from '../../DmCountry/DmCountry.js';
import { DmNameDescription } from '../../DmNameDescription/DmNameDescription.js';
import { countryCodeMap } from './countryCodeMap.js';
import FlagOutlined from './../../../../external/@ant-design/icons/es/icons/FlagOutlined.js';
import CheckOutlined from './../../../../external/@ant-design/icons/es/icons/CheckOutlined.js';

function getNormalizedData(data, value) {
  return data.map(function (item, indexUp) {
    return {
      key: item.country,
      value: item.country,
      selectable: false,
      title: /*#__PURE__*/React__default.createElement(DmCountry, {
        textStyles: {
          fontSize: '12px',
          fontWeight: '600',
          marginLeft: '7px'
        },
        name: item.countryName,
        icon: item.countryName ? /*#__PURE__*/React__default.createElement(Flag, {
          code: countryCodeMap[item.countryName.normalize('NFD').replace(/[\u0300-\u036f]/g, '')] || '',
          height: "16",
          width: "21"
        }) : /*#__PURE__*/React__default.createElement(FlagOutlined, {
          style: {
            color: '#bcbec6'
          }
        })
      }),
      children: item.accounts.map(function (account, indexDown) {
        var _account$childrenAcco;
        return {
          key: account.accountId,
          value: account.accountId,
          title: /*#__PURE__*/React__default.createElement(Tooltip, {
            placement: "left",
            title: account.accountName,
            color: "rgba(20, 3, 53, 0.8)",
            overlayClassName: "dm-company-picker-custom-tooltip-inner",
            overlayStyle: {
              position: 'relative'
            },
            zIndex: 1200
          }, /*#__PURE__*/React__default.createElement("div", {
            id: account.accountId,
            style: {
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              paddingTop: '3px',
              paddingBottom: '3px'
            }
          }, /*#__PURE__*/React__default.createElement("div", {
            style: {
              display: 'flex',
              alignItems: 'center'
            }
          }, /*#__PURE__*/React__default.createElement("div", {
            style: {
              display: 'none',
              marginRight: '10px',
              height: 'fit-content'
            }
          }, item.countryName ? /*#__PURE__*/React__default.createElement(Flag, {
            code: countryCodeMap[item.countryName.normalize('NFD').replace(/[\u0300-\u036f]/g, '')] || '',
            height: "16",
            width: "21"
          }) : /*#__PURE__*/React__default.createElement(FlagOutlined, {
            style: {
              color: '#bcbec6'
            }
          })), /*#__PURE__*/React__default.createElement(DmNameDescription, {
            name: account.accountName,
            description: account.accountId,
            style: {
              width: '150px'
            },
            size: "small"
          })), account.accountId === value && /*#__PURE__*/React__default.createElement("div", {
            "aria-label": "check-marck",
            style: {
              width: '18px',
              height: '18px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: '15px',
              backgroundColor: '#32eb71',
              borderRadius: '100px'
            }
          }, /*#__PURE__*/React__default.createElement(CheckOutlined, {
            style: {
              color: 'white',
              fontSize: '10px'
            }
          })))),
          children: (_account$childrenAcco = account.childrenAccounts) === null || _account$childrenAcco === void 0 ? void 0 : _account$childrenAcco.map(function (childAccount, indexDown) {
            return {
              key: childAccount.accountId,
              value: childAccount.accountId,
              title: /*#__PURE__*/React__default.createElement(Tooltip, {
                placement: "left",
                title: account.accountName,
                color: "rgba(20, 3, 53, 0.8)",
                overlayClassName: "dm-company-picker-custom-tooltip-inner",
                overlayStyle: {
                  position: 'relative'
                },
                zIndex: 1200
              }, /*#__PURE__*/React__default.createElement("div", {
                id: childAccount.accountId,
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  paddingTop: '3px',
                  paddingBottom: '3px'
                }
              }, /*#__PURE__*/React__default.createElement("div", {
                style: {
                  display: 'flex',
                  alignItems: 'center'
                }
              }, /*#__PURE__*/React__default.createElement("div", {
                style: {
                  display: 'none',
                  marginRight: '10px',
                  height: 'fit-content'
                }
              }, item.countryName ? /*#__PURE__*/React__default.createElement(Flag, {
                code: countryCodeMap[item.countryName.normalize('NFD').replace(/[\u0300-\u036f]/g, '')] || '',
                height: "16",
                width: "21"
              }) : /*#__PURE__*/React__default.createElement(FlagOutlined, {
                style: {
                  color: '#bcbec6'
                }
              })), /*#__PURE__*/React__default.createElement(DmNameDescription, {
                name: childAccount.accountName,
                description: childAccount.accountId,
                style: {
                  width: '130px'
                },
                size: "small"
              })), childAccount.accountId === value && /*#__PURE__*/React__default.createElement("div", {
                "aria-label": "check-marck",
                style: {
                  width: '18px',
                  height: '18px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: '15px',
                  backgroundColor: '#32eb71',
                  borderRadius: '100px'
                }
              }, /*#__PURE__*/React__default.createElement(CheckOutlined, {
                style: {
                  color: 'white',
                  fontSize: '10px'
                }
              }))))
            };
          })
        };
      })
    };
  });
}

export { getNormalizedData as default };
